<template>
  <div>
    <div class="uk-container uk-margin-small-top">
      <h2 class="uk-heading-small uk-text-center">Select Your Colors</h2>
      <p class="uk-text-center uk-width-1-2@m uk-align-center">
        Select the colors that our design team will use to create your proof.
        Start by choosing the promary color for the pattern (this color will be
        the most prominent in the design), and then choose your secondary and
        accent colors.
      </p>
      <progress
        :value="onboardingConfig.completedSteps"
        :max="onboardingConfig.totalSteps"
        class="uk-progress uk-width-1-2@m uk-align-center"
        uk-tooltip="Step 1/3"
      ></progress>

      <div class="uk-child-width-1-2@m" uk-grid>
        <div>
          <div id="card" class="uk-card uk-card-default uk-card-small">
            <div class="uk-card-media-top">
              <svg viewBox="0 0 100 75">
                <title>square</title>
                <rect
                  :style="{ fill: colors.primary.hex }"
                  width="100"
                  height="75"
                />
              </svg>
            </div>
            <div class="uk-card-body">
              <p class="uk-margin-small uk-text-muted">
                {{
                  colors.primary.colorName.toUpperCase().replace("-", " ") ||
                    "Primary Color"
                }}
              </p>
              <button
                v-if="!colors.primary.colorName"
                class="uk-button uk-button-default uk-width-1-1"
                uk-toggle="target: #selection-type"
                @click="setColorSelection('primary')"
              >
                Select
              </button>
              <button
                v-if="colors.primary.colorName"
                class="uk-button uk-button-default uk-width-1-1"
                @click="clearColor('primary')"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
        <div>
          <div class="uk-child-width-1-2" uk-grid>
            <div>
              <div id="card" class="uk-card uk-card-default uk-card-small">
                <div class="uk-card-media-top">
                  <svg viewBox="0 0 100 52">
                    <title>square</title>
                    <rect
                      :style="{ fill: colors.secondary.hex }"
                      width="100"
                      height="52"
                    />
                  </svg>
                </div>
                <div class="uk-card-body">
                  <p class="uk-margin-small uk-text-muted">
                    {{ colors.secondary.colorName || "Secondary Color" }}
                  </p>
                  <button
                    v-if="!colors.secondary.colorName"
                    class="uk-button uk-button-default uk-width-1-1"
                    uk-toggle="target: #selection-type"
                    @click="setColorSelection('secondary')"
                  >
                    Select
                  </button>
                  <button
                    v-if="colors.secondary.colorName"
                    class="uk-button uk-button-default uk-width-1-1"
                    @click="clearColor('secondary')"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div id="card" class="uk-card uk-card-default uk-card-small">
                <div class="uk-card-media-top">
                  <svg viewBox="0 0 100 52">
                    <title>square</title>
                    <rect
                      :style="{ fill: colors.accent1.hex }"
                      width="100"
                      height="52"
                    />
                  </svg>
                </div>
                <div class="uk-card-body">
                  <p class="uk-margin-small uk-text-muted">
                    {{ colors.accent1.colorName || "Accent Color" }}
                  </p>
                  <button
                    v-if="!colors.accent1.colorName"
                    class="uk-button uk-button-default uk-width-1-1"
                    uk-toggle="target: #selection-type"
                    @click="setColorSelection('accent1')"
                  >
                    Select
                  </button>
                  <button
                    v-if="colors.accent1.colorName"
                    class="uk-button uk-button-default uk-width-1-1"
                    @click="clearColor('accent1')"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div id="card" class="uk-card uk-card-default uk-card-small">
                <div class="uk-card-media-top">
                  <svg viewBox="0 0 100 52">
                    <title>square</title>
                    <rect
                      :style="{ fill: colors.accent2.hex }"
                      width="100"
                      height="52"
                    />
                  </svg>
                </div>
                <div class="uk-card-body">
                  <p class="uk-margin-small uk-text-muted">
                    {{ colors.accent2.colorName || "Accent Color" }}
                  </p>
                  <button
                    v-if="!colors.accent2.colorName"
                    class="uk-button uk-button-default uk-width-1-1"
                    uk-toggle="target: #selection-type"
                    @click="setColorSelection('accent2')"
                  >
                    Select
                  </button>
                  <button
                    v-if="colors.accent2.colorName"
                    class="uk-button uk-button-default uk-width-1-1"
                    @click="clearColor('accent2')"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div id="card" class="uk-card uk-card-default uk-card-small">
                <div class="uk-card-media-top">
                  <svg viewBox="0 0 100 52">
                    <title>square</title>
                    <rect
                      :style="{ fill: colors.accent3.hex }"
                      width="100"
                      height="52"
                    />
                  </svg>
                </div>
                <div class="uk-card-body">
                  <p class="uk-margin-small uk-text-muted">
                    {{ colors.accent3.colorName || "Accent Color" }}
                  </p>
                  <button
                    v-if="!colors.accent3.colorName"
                    class="uk-button uk-button-default uk-width-1-1"
                    uk-toggle="target: #selection-type"
                    @click="setColorSelection('accent3')"
                  >
                    Select
                  </button>
                  <button
                    v-if="colors.accent3.colorName"
                    class="uk-button uk-button-default uk-width-1-1"
                    @click="clearColor('accent3')"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-1-2 uk-align-center">
        <div class="uk-child-width-1-2" uk-grid>
          <div>
            <router-link to="/new-project/distributors/upload-logo">
              <button class="uk-button uk-button-default uk-width-1-1">
                Go Back
              </button>
            </router-link>
          </div>
          <div>
            <router-link to="/new-project/distributors/confirm">
              <button class="uk-button uk-button-primary uk-width-1-1">
                Continue
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      id="selection-type"
      class="uk-modal-container"
      uk-modal="esc-close: false; bg-close: false;"
    >
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <button
          class="uk-modal-close-default"
          type="button"
          uk-close
          @click="closeColorModal()"
        ></button>
        <div v-show="!colorMode">
          <h2>
            <center>How would you like to select your color?</center>
          </h2>
          <div class="uk-child-width-1-3@m uk-flex-center" uk-grid>
            <div>
              <div id="card" class="uk-card uk-card-default uk-card-small">
                <div class="uk-card-body">
                  <p>
                    <center>
                      Select or search from 500+ of our standard Knotty colors.
                    </center>
                  </p>
                  <button
                    class="uk-button uk-button-primary uk-width-1-1"
                    type="button"
                    @click="setColorMode('knotty')"
                  >
                    Knotty Colors
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div id="card" class="uk-card uk-card-default uk-card-small">
                <div class="uk-card-body">
                  <p>
                    <center>
                      Choose a coated or uncoated Pantone color by PMS number.
                    </center>
                  </p>
                  <button
                    class="uk-button uk-button-primary uk-width-1-1"
                    type="button"
                    @click="setColorMode('pantone')"
                  >
                    Pantone Colors
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="colorMode == 'pantone'">
          <pantone-select
            ref="pantonemodal"
            @pantoneSelected="setPantone"
          ></pantone-select>
        </div>
        <div v-show="colorMode == 'knotty'">
          <knotty-color-select
            ref="knottycolormodal"
            @knottyColorSelected="setKnottyColor"
          ></knotty-color-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import PantoneSelect from "@/components/PantoneSelect";
import KnottyColorSelect from "@/components/KnottyColorSelect";

export default {
  name: "SelectDistColors",
  components: { PantoneSelect, KnottyColorSelect },
  data() {
    return {
      onboardingConfig: {
        formType: "distributor",
        completedSteps: 3,
        totalSteps: 4,
        image: null
      },
      colorMode: "",
      colorSelection: ""
    };
  },
  computed: {
    colors() {
      return this.$store.state.newDistProject.colors;
    },
    isActive() {
      return this.$store.state.newDistProject.isActive;
    }
  },
  mounted: function() {
    if (!this.isActive) {
      this.$router.push({ name: "CreateOrgProject" });
    }
  },
  methods: {
    setColorMode(mode) {
      this.colorMode = mode;
    },
    setColorSelection(placement) {
      this.colorSelection = placement;
    },
    setKnottyColor(value) {
      let color = {
        hex: value.hex,
        colorName: value.colorName,
        colorSet: "knotty",
        selection: this.colorSelection
      };
      UIkit.modal("#selection-type").hide();
      this.colorMode = "";
      this.commitColors(color, this.colorSelection);
    },
    setPantone(value) {
      let color = {
        hex: value.hex,
        colorName: value.pantone.toUpperCase().replace("-", " "),
        colorSet: "pantone",
        selection: this.colorSelection
      };
      UIkit.modal("#selection-type").hide();
      this.colorMode = "";
      this.commitColors(color, this.colorSelection);
    },
    clearColor(placement) {
      this.$store.commit("newDistProject/clearColor", placement);
    },
    closeColorModal() {
      this.colorMode = "";
      this.$refs.pantonemodal.clearSearch();
    },
    commitColors(color) {
      this.$store.commit("newDistProject/setColors", color);
    }
  }
};
</script>

<style type="text/css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/distributor-onboarding/SelectDistColors.vue